import { FC } from "react";
import { Result } from "antd";

import { error404Message } from "@/root/consts";

const ErrorPage: FC = () => {
  return <Result status="404" title="404" subTitle={error404Message} />;
};

export default ErrorPage;
